import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
} from '@chakra-ui/react';
import { formatCOP } from 'api/administrador/refunds';

export default function ConfirmActionModal({
  isOpen,
  onClose,
  action,
  studentName,
  studentCode,
  refundAmount,
  onConfirm,
  isLoading,
}) {
  const isProceed = action === 'proceed';

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader borderBottom="1px solid" borderColor="gray.200">
          Confirmar acción
        </ModalHeader>
        <ModalBody py={4}>
          {isProceed ? (
            <>
              <Text mb={3}>
                ¿Confirmas que <strong>NO</strong> se logró retener a la estudiante{' '}
                <strong>
                  {studentName} ({studentCode})
                </strong>
                ?
              </Text>
              <Text mb={3}>
                El caso pasará a la cola <strong>&apos;Listo para pago&apos;</strong> y se procederá con la
                transferencia de <strong>{formatCOP(refundAmount)}</strong>.
              </Text>
            </>
          ) : (
            <>
              <Text mb={3}>
                ¿Confirmas que se logró <strong>retener</strong> al estudiante{' '}
                <strong>
                  {studentName} ({studentCode})
                </strong>
                ?
              </Text>
              <Text mb={3}>
                El caso se cerrará con estado <strong>Retenido</strong>.
              </Text>
            </>
          )}
          <Text fontSize="sm" color="gray.500">
            Esta acción quedará registrada en el historial del caso con tu usuario y fecha.
          </Text>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="outline" onClick={onClose} isDisabled={isLoading}>
            Cancelar
          </Button>
          <Button
            bg="#574feb"
            color="white"
            _hover={{ bg: '#4840d4' }}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {isProceed ? 'Sí, procede devolución' : 'Sí, estudiante retenido'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
